module.exports = __webpack_public_path__ + "static/fonts/AkkuratPro-Bold.510bce2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AkkuratPro-Bold.ttf
// module id = 6eCo
// module chunks = 1